import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { LocationManagerService } from './../../../../services/shared/location-manager/location-manager.service';
import { Component, EventEmitter, Inject, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { CvMapComponent } from '../cv-map/cv-map.component';

@Component({
  selector: 'app-cv-location',
  templateUrl: './cv-location.component.html',
  styleUrls: ['./cv-location.component.scss'],
  providers: [LocationManagerService]
})
export class CvLocationComponent implements OnInit {

  google_search;
  interval;
  timer: number = 3;
  geo_decoder = new google.maps.Geocoder();
  show_map = 1;
  loading = false;
  pinterval: any;
  latitude: number;
  longitude: number;
  process_bar: number = 0;
  location = {
    city: '',
    state: '',
    country: '',
    latitude: 0,
    longitude: 0
  }
  locationForm: UntypedFormGroup = new UntypedFormGroup({
    "cityId": new UntypedFormControl(0),
    "cityName": new UntypedFormControl(0),
    "latitude": new UntypedFormControl(0),
    "longitude": new UntypedFormControl(0),
    "altCityName": new UntypedFormControl(0),
    "stateId": new UntypedFormControl(0),
    "stateName": new UntypedFormControl(0),
    "countryId": new UntypedFormControl(0),
    countryCode: new UntypedFormControl(null),
    stateShortName: new UntypedFormControl(null),
    postalCode: new UntypedFormControl(null),
    countryName: new UntypedFormControl(null),
    id: new UntypedFormControl(null)
  })
  @ViewChild("addresstext", { static: false }) addresstext: any;
  getPlaceAutocompleteRefPresent = this.getPlaceAutocompletePresent.bind(this);

  constructor(
    private dialog_ref: MatDialogRef<CvLocationComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private srv: LocationManagerService
  ) { }

  ngOnInit(): void {
    if (this.data && this.data) {
      this.locationForm.patchValue(this.data)
    }
  }
  close() {
    this.dialog_ref.close();
  }
  save() {
    this.srv.saveBranchDetails(this.locationForm.value).subscribe(res => {
      if (res && res['status'] && res['data']) {
        this.locationForm.controls.id.patchValue(parseInt(res['data'].id))
        this.dialog_ref.close(this.locationForm.value)
      }
    });
    // this.dialog_ref.close(this.location)
  }
  setTimer() {
    this.show_map = 0;
    if (this.show_map != 1) {
      this.startTimer();
    }
    if (this.interval) {
      clearTimeout(this.interval);
    }
    this.interval = setTimeout(() => {
      // this.getPlaceByAddress();
    }, 3000);

    //   for(let i =0; i< 80 ;i++){
    //     this.process_bar++;
    // //   waits(1000)
    //   }
  }
  startTimer() {
    this.pinterval = setInterval(() => {
      if (this.process_bar < 90) {
        this.process_bar += 1;
      } else {
        this.process_bar = 0;
      }
    }, 1000);
  }
  pauseTimer() {
    clearInterval(this.pinterval);
  }
  getCurrentLocation() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      console.log(this.latitude)
      console.log(this.longitude)
      // this.addMarker(position.coords.latitude, position.coords.longitude);
    });
  }
  private getPlaceAutocompletePresent() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      {
      });
    types: ['address']  // 'establishment' / 'address' / 'geocode'
    // google.maps.event.addListener()
    google.maps.event.addListener(autocomplete, "place_changed", (res) => {
      const address = String(autocomplete.getPlace().formatted_address);
      if (autocomplete.getPlace().geometry && autocomplete.getPlace().geometry.location) {
        this.latitude = autocomplete.getPlace().geometry.location.lat()
        this.longitude = autocomplete.getPlace().geometry.location.lng()
        this.location.latitude = this.latitude;
        this.location.longitude = this.longitude;
        this.locationForm.controls.latitude.patchValue(this.latitude);
        this.locationForm.controls.longitude.patchValue(this.longitude);
        // this.addMarker(this.latitude, this.longitude, 1)
      }
      console.log(address)
      if (autocomplete.getPlace().geometry) {
        let address_components = autocomplete.getPlace().address_components;
        try {
          let state;
          let country;
          let pincode;
          let city;
          let addressLine1
          let addressLine2
          address_components.forEach(addr => {
            // if (addr['types'][0] == "neighborhood") {
            //   if (addressLine1) {
            //     addressLine1 = addressLine1 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine1 = addr['long_name'];

            //   }
            // }
            // else if (addr['types'][0] == "sublocality_level_3") {
            //   if (addressLine1) {
            //     addressLine1 = addressLine1 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine1 = addr['long_name'];

            //   }
            // }
            // else if (addr['types'][0] == "sublocality_level_2") {
            //   if (addressLine1) {
            //     addressLine1 = addressLine1 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine1 = addr['long_name'];

            //   }
            // }
            // else if (addr['types'][0] == "sublocality_level_1") {
            //   if (addressLine2) {
            //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine2 = addr['long_name'];

            //   }
            // }
            // // else if (addr['types'][0] == "locality") {
            // //   if (addressLine2) {
            // //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            // //   }
            // //   else {
            // //     addressLine2 = addr['long_name'];

            // //   }
            // // }
            // else if (addr['types'][0] == "route") {
            //   if (addressLine2) {
            //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine2 = addr['long_name'];

            //   }
            // }

            if (addr['types'][0] == 'administrative_area_level_1') {
              state = addr['long_name'];
              this.locationForm.controls.stateName.patchValue(state);
              this.locationForm.controls.stateShortName.patchValue(addr['short_name']);

            }
            else if (addr['types'][0] == 'locality') {
              city = addr['long_name'];
              this.locationForm.controls.cityName.patchValue(city);

            }
            else if (addr['types'][0] == 'administrative_area_level_2') {
              let altCity = addr['long_name'];
              if (altCity != city) {
                this.locationForm.controls.altCityName.patchValue(altCity);
              }

            }

            else if (addr['types'][0] == 'country') {
              country = addr['long_name'];
              this.locationForm.controls.countryName.patchValue(country);
              this.locationForm.controls.countryCode.patchValue(addr['short_name']);

            }
            else if (addr['types'][0] == 'postal_code') {
              pincode = addr['long_name'];
              this.locationForm.controls.postalCode.patchValue(pincode);
            }

          });
          this.location.city = city;
          this.location.state = state;
          this.location.country = country;

        }
        catch (err) {
          console.log(err)
        }
      }
      else {
        this.getPlaceByAddressPresent();
      }

    });
  }
  getPlaceByAddressPresent() {
    this.timer = 10;
    const service = new google.maps.places.PlacesService(this.addresstext.nativeElement).findPlaceFromQuery({
      query: this.google_search,
      fields: ['name', 'geometry', 'formatted_address'],
    }, res => {
      // 
      this.pauseTimer();
      this.process_bar = 0;
      if (res && res[0]) {
        let address_components = res[0].address_components;
        try {
          let state;
          let country;
          let pincode;
          let city;
          let addressLine1
          let addressLine2
          address_components.forEach(addr => {
            // if (addr['types'][0] == "neighborhood") {
            //   if (addressLine1) {
            //     addressLine1 = addressLine1 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine1 = addr['long_name'];

            //   }
            // }
            // else if (addr['types'][0] == "sublocality_level_3") {
            //   if (addressLine1) {
            //     addressLine1 = addressLine1 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine1 = addr['long_name'];

            //   }
            // }
            // else if (addr['types'][0] == "sublocality_level_2") {
            //   if (addressLine1) {
            //     addressLine1 = addressLine1 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine1 = addr['long_name'];

            //   }
            // }
            // else if (addr['types'][0] == "sublocality_level_1") {
            //   if (addressLine2) {
            //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine2 = addr['long_name'];

            //   }
            // }
            // // else if (addr['types'][0] == "locality") {
            // //   if (addressLine2) {
            // //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            // //   }
            // //   else {
            // //     addressLine2 = addr['long_name'];

            // //   }
            // // }
            // else if (addr['types'][0] == "route") {
            //   if (addressLine2) {
            //     addressLine2 = addressLine2 + ',' + addr['long_name'];
            //   }
            //   else {
            //     addressLine2 = addr['long_name'];

            //   }
            // }


            if (addr['types'][0] == 'administrative_area_level_1') {
              state = addr['long_name'];
              this.locationForm.controls.stateName.patchValue(state);
              this.locationForm.controls.stateShortName.patchValue(addr['short_name']);

            }
            else if (addr['types'][0] == 'locality') {
              city = addr['long_name'];
              city = addr['long_name'];
              this.locationForm.controls.cityName.patchValue(city);

            }
            else if (addr['types'][0] == 'administrative_area_level_2') {
              let altCity = addr['long_name'];
              if (altCity != city) {
                this.locationForm.controls.altCityName.patchValue(altCity);
              }

            }
            else if (addr['types'][0] == 'country') {
              country = addr['long_name'];
              this.locationForm.controls.countryName.patchValue(country);
              this.locationForm.controls.countryCode.patchValue(addr['short_name']);

            }
            else if (addr['types'][0] == 'postal_code') {
              pincode = addr['long_name'];
              this.locationForm.controls.postalCode.patchValue(pincode);

            }

          });
          this.location.city = city;
          this.location.state = state;
          this.location.country = country;
        }
        catch (err) {
          console.log(err)
        }
      }
      else {
      }
    });
    // let timer = setTimeout(()=>{
    //   this.process_bar +=5;
    // },1000);
  }


}
